import { MEDIA, TICKETING_LOGO_MEDIA_TAG_NAME } from '@/utils/CONST';
import { useGetList } from 'react-admin';
import { composeMediaFmDownloadUrl, composeUri } from '@/utils/compose';
import { useGetOne } from 'react-admin';
import extractIdFromURI from '@/utils/id';
import { useQueryClient } from '@tanstack/react-query';

interface Props {
    avatarId: string | undefined;
}

const useGetLogoImage = ({ avatarId }: Props) => {
    const queryClient = useQueryClient();

    const {
        data: fmData,
        isLoading: isLoadingFmData,
        refetch: refetchFmData,
    } = useGetList(
        'smartConnectView/file_system_mappers',
        {
            filter: {
                'parent.parent.name': `sc:folder-avatar:${avatarId}`,
                lvl: 5,
                'tags.name': [TICKETING_LOGO_MEDIA_TAG_NAME],
            },
            meta: {
                basePath: 'fm',
            },
        },
        { enabled: avatarId !== undefined },
    );

    const mediaId =
        fmData !== undefined && fmData.length > 0
            ? composeUri(`${MEDIA}`, fmData[0].metadata['metadata.extra']['coreapi.mediaid'])
            : undefined;

    const { data: mediaData, isLoading: isLoadingMediaData } = useGetOne(
        MEDIA,
        {
            id: mediaId,
        },
        {
            enabled: mediaId !== undefined,
        },
    );

    const handleRemoveMediaDataQuery = () => {
        if (mediaId) {
            queryClient.removeQueries({ queryKey: [MEDIA, 'getOne', mediaId] });
        }
    };

    return {
        mediaData: mediaData
            ? {
                  ...mediaData,
                  downloadUrl: composeMediaFmDownloadUrl(
                      extractIdFromURI(mediaData.id) as string,
                      mediaData.contentUrlTokenAccess,
                  ),
              }
            : undefined,
        isLoading: isLoadingFmData || isLoadingMediaData,
        refetch: () => {
            handleRemoveMediaDataQuery();
            refetchFmData();
        },
    };
};

export default useGetLogoImage;
